import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import WebConfigSubDomainInfo from "./WebConfigSubDomainInfo";
import WebPagination from "../../etc/WebPagination";

const WebConfigSubDomainList = ({ userKind, isStandardType, list_subDomain, goToConfigPage, goToConfigMemberPage, goToPassListPage, toggleModalOpened, togglePWModalOpened, toggleSubDomainAdminModalOpened, toggleCreateSubDomainAdminModalOpened }) => {
    const { t } = useTranslation();

    // 한 페이지에 보여줄 개수 (10/20/30/50/100 선택 가능)
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [offset, setOffset] = useState((page - 1) * limit);
    const [blockNum, setBlockNum] = useState(0);

    // 컴포넌트 초기 로드 여부를 추적하는 상태 추가
    const [isFirstLoad, setIsFirstLoad] = useState(true);

    useEffect(() => {
        // console.log("WebConfigSubDomainList visible");

        return () => {
            // console.log("WebConfigSubDomainList invisible");

            // 컴포넌트가 언마운트될 때 초기화
            setIsFirstLoad(true);
        }
    }, []);

    useEffect(() => {
        let offset = (page - 1) * limit;
        setOffset(offset);
    }, [page, limit]);

    useEffect(() => {
        // 초기 로드 시에만 페이지를 1로 설정하고, 이후에는 현재 페이지 유지
        if (isFirstLoad) {
            setPage(1);
            setOffset((page - 1) * limit);
            setIsFirstLoad(false);
        }

        /* return () => {
            setPage(1);
            setOffset((page - 1) * limit);
        } */
    }, [list_subDomain, page, isFirstLoad]);

    return (
        list_subDomain && list_subDomain.length > 0 ?
            <>
                <WebPagination
                    total={list_subDomain.length <= 0 ? 1 : list_subDomain.length}
                    limit={limit}
                    setLimit={setLimit}
                    page={page}
                    setPage={setPage}
                    blockNum={blockNum}
                    setBlockNum={setBlockNum}
                />
                {/* teacher/class 탭과 동일한 table-container / list-table 스타일 (내용·데이터 흐름은 동일) */}
                <div className="table-container">
                    {/* 260804-7 서브 도메인 이름 말줄임(...) 실제 동작을 위해 table-layout:fixed 적용 */}
                    <table className="list-table admin-ellipsis-table">
                        <thead>
                            <tr>
                                <th style={{ width: '30%' }} className="text-center">
                                    {t("서브_도메인_이름", { ns: "admin" })}
                                </th>
                                <th style={{ width: '25%' }} className="text-center">
                                    <div className="only-web w-100">
                                        <span className="area-60">{t("접속현황", { ns: "admin" })}</span>
                                        <span className="area-40">{t("멤버", { ns: "common" })}</span>
                                    </div>
                                    <div className="only-mobile w-100" style={{ justifyContent: 'center' }}>
                                        {t("사용자", { ns: "admin" })}
                                    </div>
                                </th>
                                <th style={{ width: '30%' }} className="text-center">
                                    <div className="only-web w-100">
                                        <span className="area-50">{t("팀업", { ns: "chat" })}</span>
                                        <span className="area-50">{t("클래스", { ns: "live" })}</span>
                                    </div>
                                    <div className="only-mobile w-100">
                                        {t("팀업", { ns: "chat" })}/{t("클래스", { ns: "live" })}
                                    </div>
                                </th>
                                <th style={{ width: '15%' }} className="text-center">
                                    {
                                        isStandardType &&
                                        t("이용권", { ns: "pass" })
                                    }
                                </th>
                            </tr>
                        </thead>
                        {
                            // list_subDomain.map((subDomain, idx) => (
                            list_subDomain.slice(offset, offset + limit).map((subDomain, idx) => (
                                <WebConfigSubDomainInfo
                                    key={"config-" + subDomain.subDomainSeq}
                                    idx={idx}
                                    userKind={userKind}
                                    isStandardType={isStandardType}
                                    subDomain_info={subDomain}
                                    goToConfigPage={goToConfigPage}
                                    goToConfigMemberPage={goToConfigMemberPage}
                                    goToPassListPage={goToPassListPage}
                                    toggleModalOpened={toggleModalOpened}
                                    togglePWModalOpened={togglePWModalOpened}
                                    toggleSubDomainAdminModalOpened={toggleSubDomainAdminModalOpened}
                                    toggleCreateSubDomainAdminModalOpened={toggleCreateSubDomainAdminModalOpened}
                                />
                            ))
                        }
                    </table>
                </div>
            </> :
            <div className="d-flex view m-3 justify-content-center grey-text">
                {t("서브_도메인_목록_없음", { ns: "admin" })}
            </div>
    );
}

export default WebConfigSubDomainList;